"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetShell = WidgetShell;
exports.DashboardGrid = DashboardGrid;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_grid_layout_1 = require("react-grid-layout");
require("react-grid-layout/css/styles.css");
require("react-resizable/css/styles.css");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
function WidgetShell(_a) {
    var title = _a.title, subtitle = _a.subtitle, tooltip = _a.tooltip, loading = _a.loading, empty = _a.empty, emptyText = _a.emptyText, headerRight = _a.headerRight, children = _a.children, flush = _a.flush, hideTitle = _a.hideTitle, noShell = _a.noShell;
    var body = loading ? ((0, jsx_runtime_1.jsx)("div", { className: "flex h-full items-center justify-center", children: (0, jsx_runtime_1.jsx)(react_1.Spinner, {}) })) : empty ? ((0, jsx_runtime_1.jsx)("div", { className: "flex h-full items-center justify-center text-xs text-muted", children: emptyText !== null && emptyText !== void 0 ? emptyText : "No data for this range" })) : (children);
    if (noShell) {
        if (loading) {
            return (0, jsx_runtime_1.jsx)(react_1.Skeleton, { className: "h-full w-full rounded-lg" });
        }
        return (0, jsx_runtime_1.jsx)("div", { className: "h-full w-full", children: body });
    }
    return ((0, jsx_runtime_1.jsxs)(react_1.Card, { className: "h-full overflow-hidden shadow-sm rounded-lg", children: [(!hideTitle && title) && ((0, jsx_runtime_1.jsxs)(react_1.Card.Header, { className: "flex items-start justify-between gap-3 px-4 py-3", children: [(0, jsx_runtime_1.jsxs)("div", { className: "min-w-0", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-1 truncate text-xs font-medium text-muted", children: [(0, jsx_runtime_1.jsx)("span", { className: "truncate", children: title }), tooltip && ((0, jsx_runtime_1.jsxs)(react_1.Tooltip, { delay: 0, children: [(0, jsx_runtime_1.jsx)(react_1.Tooltip.Trigger, { children: (0, jsx_runtime_1.jsx)("span", { className: "inline-flex cursor-pointer", children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:info-circle-linear", className: "text-sm text-muted" }) }) }), (0, jsx_runtime_1.jsx)(react_1.Tooltip.Content, { className: "max-w-xs whitespace-normal break-words text-xs leading-snug p-2", children: tooltip })] }))] }), subtitle && (0, jsx_runtime_1.jsx)("div", { className: "mt-0.5 truncate text-xs text-muted", children: subtitle })] }), headerRight] })), (0, jsx_runtime_1.jsx)(react_1.Card.Content, { className: "relative ".concat(flush ? "p-0" : "p-2"), children: body })] }));
}
var COLS = 12;
var ROW_HEIGHT = 60;
var MARGIN = [12, 12];
var CONTAINER_PADDING = [0, 0];
var MAX_ROWS = 100;
function pickBreakpoint(width) {
    if (width < 480)
        return "xs";
    if (width < 900)
        return "sm";
    return "lg";
}
function effectiveWidth(widget, breakpoint) {
    if (breakpoint === "lg")
        return widget.w;
    if (widget.noShell) {
        if (breakpoint === "xs")
            return 6;
        return 4;
    }
    return 12;
}
function packLayout(widgets, breakpoint) {
    if (breakpoint === "lg") {
        return widgets.map(function (_a) {
            var x = _a.x, y = _a.y, w = _a.w, h = _a.h, i = _a.i;
            return ({ x: x, y: y, w: w, h: h, i: i });
        });
    }
    var sorted = __spreadArray([], widgets, true).sort(function (first, second) { return (first.y - second.y) || (first.x - second.x); });
    var currentY = 0;
    var currentX = 0;
    var rowHeight = 0;
    return sorted.map(function (widget) {
        var columnSpan = effectiveWidth(widget, breakpoint);
        if (currentX + columnSpan > COLS) {
            currentY += rowHeight;
            currentX = 0;
            rowHeight = 0;
        }
        var placed = { i: widget.i, x: currentX, y: currentY, w: columnSpan, h: widget.h };
        currentX += columnSpan;
        if (widget.h > rowHeight)
            rowHeight = widget.h;
        return placed;
    });
}
function DashboardGrid(_a) {
    var widgets = _a.widgets;
    var _b = (0, react_grid_layout_1.useContainerWidth)(), containerRef = _b.containerRef, width = _b.width, mounted = _b.mounted;
    if (!mounted || width === null) {
        return (0, jsx_runtime_1.jsx)("div", { ref: containerRef });
    }
    var bp = pickBreakpoint(width);
    var layout = packLayout(widgets, bp);
    return ((0, jsx_runtime_1.jsx)("div", { ref: containerRef, children: (0, jsx_runtime_1.jsx)(react_grid_layout_1.GridLayout, { width: width, layout: layout, gridConfig: {
                cols: COLS,
                rowHeight: ROW_HEIGHT,
                margin: MARGIN,
                containerPadding: CONTAINER_PADDING,
                maxRows: MAX_ROWS,
            }, dragConfig: { enabled: false }, resizeConfig: { enabled: false }, compactor: react_grid_layout_1.verticalCompactor, children: widgets.map(function (widget) {
                var _a;
                return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(WidgetShell, { title: (_a = widget.title) !== null && _a !== void 0 ? _a : "", tooltip: widget.tooltip, hideTitle: widget.hideTitle, loading: widget.loading, empty: widget.empty, emptyText: widget.emptyText, noShell: widget.noShell, children: widget.content }) }, widget.i));
            }) }) }));
}
